<h3 class="m-t-0">
  {{ componentName }} ({{ componentType }}) - Default
  {{ componentDefaultPrice | currency: "USD" }}
</h3>

<kendo-textbox
  placeholder="Start typing a combo name"
  (valueChange)="handleFilter($event)"
>
  <ng-template kendoPrefixTemplate>
    <button kendoButton fillMode="flat">
      <fa-icon [icon]="['fas', 'magnifying-glass']"></fa-icon>
    </button>
  </ng-template>
</kendo-textbox>

<br />
<br />

<div *ngIf="overrides.total > 0">
  <app-data-grid
    #grid
    [mode]="locked ? 'view' : 'edit'"
    [maxHeight]="500"
    [maxWidth]="800"
    [state]="state"
    [fontSize]="fontSize"
    (valueChange)="cacheChanges()"
    [columns]="columns"
    [filterable]="'menu'"
    [dataItems]="overrides"
    (dataStateChange)="fetchOverrides($event)"
  >
    <ng-template
      columnTemplate
      field="comboName"
      let-row="row"
      let-column="column"
    >
      {{ row[column.field] }}
      <button
        *ngIf="row.status == 'Pending'"
        kendoButton
        [title]="'This item is pending sync to PAR'"
        class="m-l-4 info-bg badge-button"
        size="small"
        rounded="full"
      >
        Pending
      </button>

      <button
        *ngIf="row.hasDirty()"
        kendoButton
        [title]="'This item has unsaved changes'"
        class="m-l-4 warning-bg badge-button"
        size="small"
        rounded="full"
      >
        Unsaved
      </button>

      <button
        *ngIf="row.status == 'Scheduled'"
        kendoButton
        [title]="'This item is scheduled to sync with PAR'"
        class="m-l-4 success-bg badge-button"
        size="small"
        rounded="full"
      >
        Scheduled
      </button>
    </ng-template>

    <ng-template
      columnTemplate
      field="newIsOverridePrice"
      let-row="row"
      let-column="column"
    >
      <kendo-switch
        [style.height.rem]="2 * fontSize"
        [disabled]="locked || onlyEntrees"
        size="small"
        [checked]="!!row[column.field]"
        (valueChange)="onSwitchOverride(row, column.field, $event)"
      ></kendo-switch>
    </ng-template>

  <ng-template     
    columnTemplate
    field="newOverrideDeliveryPrice"
    let-row="row"
    let-column="column">
      <app-editable-column
        *ngIf="!row.locked"
        kendoTooltip
        [title]="row.isDeliveryAvailable == false ? 'This item is not available for delivery pricing.': ''"
       [fontSize]="fontSize"
       [dataItem]="row"
       [column]="column"
       (valueChange)="onValueChange($event.dataItem, $event.field)"
       [disabled]="row.isDeliveryAvailable == false"
      [placeholder]="row.isDeliveryAvailable == false ? 'N/A' : ''"
     ></app-editable-column>

      <app-column
       *ngIf="row.locked"
       [fontSize]="fontSize"
       [data]="row"
       [column]="column"
       ></app-column>
  </ng-template>
  </app-data-grid>
</div>

<br />
<br />

<kendo-badge-container>
  <button
    kendoButton
    size="small"
    fillMode="outline"
    [disabled]="cache.size == 0"
    (click)="saveChanges()"
    themeColor="primary"
  >
    Save
  </button>
  <kendo-badge
    *ngIf="cache.size > 0"
    size="small"
    rounded="full"
    [align]="{ vertical: 'top', horizontal: 'end' }"
    themeColor="success"
    >{{ cache.size }}</kendo-badge
  >
</kendo-badge-container>
